import {ToastData, ToastOptions, ToastyService} from 'ng2-toasty';
import {Injectable} from '@angular/core';

export const toastOptions: ToastOptions = {
  title: '',
  msg: 'The message',
  showClose: true,
  timeout: 2000,
  theme: 'bootstrap',
  onAdd: (toast: ToastData) => {
    console.log('Toast ' + toast.id + ' has been addedDocument!');
  },
  onRemove: (toast: ToastData) => {
    console.log('Toast ' + toast.id + ' has been removed!');
  }
};

@Injectable({
  providedIn: 'root'
})
export class SharedToastService {

  constructor(private toastyService: ToastyService) {}

  public info(message: {title?: string, msg: string}) {
    this.toastyService.info(Object.assign({}, toastOptions, message));

  }
  public error(message: {title?: string, msg: string}) {
    this.toastyService.error(Object.assign({}, toastOptions, message));

  }

  public warning(message: {title?: string, msg: string}) {
    this.toastyService.warning(Object.assign({}, toastOptions, message));

  }


}
